/* ZELVORA BEAUTY - theme.js */
(function () {
  var toggle = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  var money = function (cents) {
    var fmt = (window.ZELVORA && window.ZELVORA.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  };

  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var productJson = form.getAttribute('data-product-json');
    var product; try { product = JSON.parse(document.getElementById(productJson).textContent); } catch (e) { return; }
    var variantSelect = form.querySelector('[name="id"]');
    var planRadios = form.querySelectorAll('[name="purchase_type"]');
    var planSelect = form.querySelector('[data-plan-select]');
    var planInput = form.querySelector('[name="selling_plan"]');
    var priceEl = document.querySelector('[data-product-price]');
    var compareEl = document.querySelector('[data-product-compare]');
    var msg = form.querySelector('[data-form-message]');
    var btn = form.querySelector('[type="submit"]');

    function currentVariant() {
      var id = parseInt(variantSelect.value, 10);
      return product.variants.filter(function (v) { return v.id === id; })[0];
    }
    function currentPlanId() {
      var sub = form.querySelector('[name="purchase_type"][value="subscribe"]');
      if (sub && sub.checked && planSelect) return planSelect.value;
      return '';
    }
    function render() {
      var v = currentVariant(); if (!v) return;
      var planId = currentPlanId();
      var price = v.price, compare = v.compare_at_price;
      if (planId && v.selling_plan_allocations) {
        var alloc = v.selling_plan_allocations.filter(function (a) { return String(a.selling_plan_id) === String(planId); })[0];
        if (alloc) { price = alloc.per_delivery_price || alloc.price; compare = v.price; }
      }
      if (planInput && planRadios.length) planInput.value = planId;
      if (form.querySelector('[data-plans]')) { return; }
      if (priceEl) priceEl.textContent = money(price);
      if (compareEl) { if (compare && compare > price) { compareEl.textContent = money(compare); compareEl.hidden = false; } else { compareEl.hidden = true; } }
      if (btn) { btn.disabled = !v.available; var sp = btn.querySelector('span'); if (sp) sp.textContent = v.available ? btn.getAttribute('data-add-text') : btn.getAttribute('data-soldout-text'); }
      var subBox = form.querySelector('[data-plan-box]');
      if (subBox) subBox.hidden = !planId;
    }
    if (variantSelect) variantSelect.addEventListener('change', render);
    planRadios.forEach(function (r) { r.addEventListener('change', render); });
    if (planSelect) planSelect.addEventListener('change', render);
    render();

    var mainImg = document.querySelector('[data-main-image]');
    document.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (mainImg) { mainImg.src = t.getAttribute('data-src'); mainImg.srcset = ''; }
        document.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(form);
      var payload = { items: [{ id: fd.get('id'), quantity: parseInt(fd.get('quantity') || '1', 10) }] };
      var sp = fd.get('selling_plan'); if (sp) payload.items[0].selling_plan = sp;
      var props = {}; var hasProps = false;
      fd.forEach(function (val, key) { var m = key.match(/^properties\[(.+)\]$/); if (m && val) { props[m[1]] = val; hasProps = true; } });
      if (hasProps) payload.items[0].properties = props;
      btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(payload) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          btn.disabled = false;
          if (!res.ok) { if (msg) msg.textContent = res.j.description || res.j.message || 'Could not add to cart.'; return; }
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; c.setAttribute('data-count', cart.item_count); });
            if (window.ZCart && window.ZCart.open) { window.ZCart.open(cart); } else { window.location.href = '/cart'; }
          });
        })
        .catch(function () { btn.disabled = false; if (msg) msg.textContent = 'Something went wrong. Please try again.'; });
    });
  });

  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () { input.closest('form').submit(); });
  });
})();

/* Customer video wall - autoplays muted while on screen; tap a video for sound */
(function () {
  var cards = document.querySelectorAll('.video-card');
  if (!cards.length) return;
  var loud = null; // the one card currently playing with sound
  function playMuted(card) {
    var v = card.querySelector('[data-video]');
    if (!v) return;
    v.muted = true;
    sync(card);
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
    card.classList.add('is-playing');
  }
  function sync(card) {
    var v = card.querySelector('[data-video]'), s = card.querySelector('[data-video-sound]');
    if (!s || !v) return;
    s.hidden = false;
    var on = s.querySelector('[data-sound-on]'), off = s.querySelector('[data-sound-off]');
    if (on && off) { on.hidden = v.muted; off.hidden = !v.muted; }
    s.setAttribute('aria-label', v.muted ? 'Turn sound on' : 'Turn sound off');
  }
  function toggleSound(card) {
    var v = card.querySelector('[data-video]');
    if (!v) return;
    if (v.muted) {
      if (loud && loud !== card) { var lv = loud.querySelector('[data-video]'); if (lv) lv.muted = true; sync(loud); }
      v.muted = false; loud = card;
      var p = v.play();
      if (p && p.catch) p.catch(function () { v.muted = true; sync(card); v.play().catch(function () {}); });
    } else {
      v.muted = true; if (loud === card) loud = null;
    }
    sync(card);
  }
  cards.forEach(function (card) {
    var video = card.querySelector('[data-video]');
    var play = card.querySelector('[data-video-play]');
    var sound = card.querySelector('[data-video-sound]');
    if (!video) return;
    sync(card);
    if (play) play.addEventListener('click', function () { playMuted(card); toggleSound(card); });
    video.addEventListener('click', function () { toggleSound(card); });
    if (sound) sound.addEventListener('click', function (e) { e.stopPropagation(); toggleSound(card); });
  });
  if ('IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var c = e.target, v = c.querySelector('[data-video]');
        if (!v) return;
        if (e.isIntersecting) { playMuted(c); }
        else { v.pause(); if (loud === c) { v.muted = true; sync(c); loud = null; } c.classList.remove('is-playing'); }
      });
    }, { threshold: 0.35 });
    cards.forEach(function (c) { vio.observe(c); });
  } else {
    cards.forEach(playMuted);
  }
})();
